import { zodResolver } from "@hookform/resolvers/zod";
import { Lock } from "lucide-react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { Input } from "shared/components/inputs/Input";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import { z } from "zod";
import { apiForgotPassword } from "../../../shared/services/api";
import styles from "./NovaSenha.module.scss";

/* ================================
   VALIDAÇÃO
================================ */

const schema = z
  .object({
    senha: z
      .string()
      .min(
        8,
        "Mínimo 8 caracteres, incluindo uma letra maiúscula, uma letra minúscula e um caractere especial.",
      ),
    confirmarSenha: z.string().min(8, "Confirme sua senha"),
  })
  .refine((data) => data.senha === data.confirmarSenha, {
    message: "As senhas não coincidem",
    path: ["confirmarSenha"],
  });

type FormData = z.infer<typeof schema>;

export const NovaSenha = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");
  const codigo = location.state?.codigo;
  const email = location.state?.email;
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<FormData>({
    resolver: zodResolver(schema),
    mode: "onChange",
  });
  const senha = watch("senha");
  const confirmarSenha = watch("confirmarSenha");
  const botaoDesabilitado =
    !senha ||
    !confirmarSenha ||
    senha.length < 8 ||
    senha !== confirmarSenha ||
    loading;
  const onSubmit = async (data: FormData) => {

    setLoading(true);
    setErro("");

    try {

      await apiForgotPassword(email, codigo, data.senha);

      navigate("/login");
    } catch (error: any) {

      console.error("ERRO COMPLETO:", error);
      console.error("NAME:", error?.name);
      console.error("MESSAGE:", error?.message);

      setErro(
        error?.response?.data?.message ||
          error?.message ||
          "Erro ao redefinir senha",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer icon={<Lock size={18} />} title="Nova Senha">
      <form className={styles.page} onSubmit={handleSubmit(onSubmit)}>
        <h4 className={styles.titulo}>Defina sua nova senha</h4>
        <div>
          <Input
            placeholder="Nova Senha"
            type="password"
            name="senha"
            register={register}
            error={errors.senha?.message}
            customClass={styles.customInputClass}
          />
          <p className={styles.obs}>
            A senha deve conter pelo menos 8 caracteres, incluindo uma letra
            maiúscula, uma letra minúscula e um caractere especial.
          </p>
        </div>
        <Input
          placeholder="Confirmar Senha"
          type="password"
          name="confirmarSenha"
          register={register}
          error={errors.confirmarSenha?.message}
          customClass={styles.customInputClass}
        />
        {erro && <p className={styles.error}>{erro}</p>}
        <button
          className={`${styles.btnAvance} ${
            botaoDesabilitado ? styles.disabled : ""
          }`}
          type="submit"
          disabled={botaoDesabilitado}
        >
          {loading ? "Salvando..." : "Confirmar"}
        </button>
      </form>
    </PageContainer>
  );
};
